import { render, staticRenderFns } from "./avm_demo.vue?vue&type=template&id=056dd2de&scoped=true&"
import script from "./avm_demo.vue?vue&type=script&lang=js&"
export * from "./avm_demo.vue?vue&type=script&lang=js&"
import style0 from "@/assets/redesigned/index.scss?vue&type=style&index=0&lang=scss&"
import style1 from "./avm_demo.vue?vue&type=style&index=1&id=056dd2de&scoped=true&lang=css&"
import style2 from "./avm_demo.vue?vue&type=style&index=2&id=056dd2de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056dd2de",
  null
  
)

export default component.exports